<template>
    <div>
        <el-drawer
            :visible.sync="showModal"
            append-to-body
            direction="btt"
            @closed="resetForm"
            size="95%"
            :style="{
                maxWidth: '500px',
                left: '50%',
                transform: 'translateX(-50%)',
            }"
        >
            <template slot="title" class="mb-0">
                <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                    <el-tag type="warning">
                        <i class="el-icon-edit-outline"></i>
                    </el-tag>
                    <h5 class="font-weight-semibold mb-0">Editar Notificação</h5>
                </div>
            </template>

            <div class="px-4 pb-3 d-flex flex-grow-1 flex-column justify-content-between" :style="{ height: '100%' }">
                <el-form
                    :model="payload"
                    ref="notificacaoForm"
                    label-position="top"
                    status-icon
                >
                    <el-row :gutter="12">
                        <!-- Titulo -->
                        <el-col>
                            <el-form-item
                                prop="title"
                                :rules="[
                                    { required: true, message: 'O título é obrigatório' },
                                    { validator: validateMin(3, 'O título deve possuir no mínimo 3 caracteres'), trigger: 'blur' },
                                    { max: 255, message: 'O título deve possuir no máximo 255 caracteres', trigger: 'blur' },
                                ]"
                            >
                                <label>Título</label>
                                <el-input
                                    v-model="payload.title"
                                    placeholder="Digite o título"
                                    :disabled="isSubmiting"
                                    maxlength="255"
                                    clearable
                                />
                            </el-form-item>
                        </el-col>

                        <!-- Corpo -->
                        <el-col>
                            <el-form-item
                                prop="body"
                                :rules="[
                                    { required: true, message: 'A mensagem é obrigatória' },
                                ]"
                            >
                                <label>Mensagem</label>
                                <el-input
                                    v-model="payload.body"
                                    type="textarea"
                                    :rows="4"
                                    placeholder="Digite a mensagem"
                                    :disabled="isSubmiting"
                                />
                            </el-form-item>
                        </el-col>

                        <!-- Frequencia -->
                        <el-col>
                            <el-form-item
                                prop="frequencia"
                                :rules="[
                                    { required: true, message: 'A frequência é obrigatória', trigger: 'change' },
                                ]"
                            >
                                <label>Frequência</label>
                                <el-select
                                    v-model="payload.frequencia"
                                    placeholder="Selecione a frequência"
                                    :disabled="isSubmiting"
                                    class="w-100"
                                >
                                    <el-option
                                        v-for="frequencia in frequencias"
                                        :key="frequencia.value"
                                        :label="frequencia.text"
                                        :value="frequencia.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <!-- Classe -->
                        <el-col>
                            <el-form-item
                                prop="classe"
                                :rules="[
                                    { required: true, message: 'A classe é obrigatória', trigger: 'change' },
                                ]"
                            >
                                <label>Classe</label>
                                <el-select
                                    v-model="payload.classe"
                                    placeholder="Selecione uma classe"
                                    :disabled="isSubmiting"
                                    class="w-100"
                                >
                                    <el-option
                                        v-for="classe in classes"
                                        :key="classe.value"
                                        :label="classe.text"
                                        :value="classe.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <!-- Enviar em -->
                        <!-- <el-col>
                            <el-form-item
                                prop="enviar_em"
                                :rules="[
                                    { required: true, message: 'A data de envio é obrigatória', trigger: 'change' },
                                ]"
                            >
                                <label>Enviar em</label>
                                <el-date-picker
                                    v-model="payload.enviar_em"
                                    type="datetime"
                                    placeholder="Selecione data e hora"
                                    format="dd/MM/yyyy HH:mm"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    :disabled="isSubmiting"
                                    class="w-100"
                                />
                            </el-form-item>
                        </el-col> -->

                        <el-col>
                            <el-divider class="my-1"></el-divider>
                        </el-col>

                        <!-- Ativo -->
                        <el-col>
                            <div class="bg-white border rounded-lg p-2 d-flex align-items-center justify-content-between mb-3" :style="{ gap: '12px' }">
                                <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                                    <el-button :type="payload.ativo ? 'success': 'danger'" plain circle :style="{ pointerEvents: 'none' }">
                                        <i v-if="payload.ativo" class="el-icon-unlock"></i>
                                        <i v-else class="el-icon-lock"></i>
                                    </el-button>
                                    <h6 class="mb-0 font-weight-bold">Notificação {{ payload.ativo ? 'Ativa' : 'Inativa' }}</h6>
                                </div>

                                <el-form-item class="mb-0">
                                    <el-switch
                                        v-model="payload.ativo"
                                        active-text="Ativa"
                                        inactive-text="Inativa"
                                    />
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>

                <!-- Actions -->
                <el-row class="mt-3">
                    <el-col>
                        <div class="d-flex align-items-center justify-content-end">
                            <el-button
                                plain
                                type="danger"
                                :disabled="isSubmiting"
                                @click="() => {
                                    toggleModal();
                                    resetForm();
                                }"
                            >
                                Cancelar
                            </el-button>

                            <el-button
                                type="primary"
                                plain
                                :disabled="isSubmiting"
                                @click="onSubmit"
                            >
                                <i v-if="isSubmiting" class="el-icon-loading"></i>
                                <i v-else class="fas fa-check-circle"></i>
                                Salvar
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-drawer>
    </div>
</template>
<script>
    // Components
    import {
        Row,
        Col,
        Button,
        Input,
        Notification,
        DatePicker,
        Drawer,
        Switch,
        Select,
        Option,
        Divider,
        Tag,
    } from "element-ui";

    // Utils
    import { validateMin } from "@/schemas/generalSchema";

    // Api
    import { NotificacaoApi } from "@/api/NotificacaoApi";

    const notificacaoApi = new NotificacaoApi();

    export default {
        data() {
            return {
                id: null,
                payload: {
                    title: null,
                    body: null,
                    frequencia: null,
                    classe: null,
                    // enviar_em: null,
                    ativo: false,
                },
                showModal: false,
                isLoading: false,
                isSubmiting: false,
                resource: null,
                frequencias: [
                    { text: 'Sem limite', value: 'sem_limite' },
                    { text: 'Diária', value: 'diaria' },
                    { text: 'Semanal', value: 'semanal' },
                ],
                classes: [
                    { text: 'Todas', value: 'Todas' },
                    { text: 'A', value: 'A' },
                    { text: 'G', value: 'G' },
                    { text: 'S', value: 'S' },
                ],
            }
        },
        methods: {
            async show() {
                try {
                    this.isLoading = true;

                    const res = await notificacaoApi.show(this.id);
                    this.resource = res?.data ?? res;
                } catch (err) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter a notificação! Algo inesperado ocorreu.'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            onSubmit() {
                this.$refs.notificacaoForm.validate( async (valid) => {
                    if (!valid) {
                        this.$message({
                            message: 'Atenção, há campo(s) obrigatório(s) não preenchido(s)',
                            type: 'warning',
                            showClose: true,
                        });

                        return false
                    }

                    this.isSubmiting = true;

                    try {
                        await notificacaoApi.update(this.payload, this.id);

                        Notification.success({
                            title: 'Sucesso',
                            message: 'Notificação atualizada com sucesso!'
                        });

                        this.toggleModal();
                        this.resetForm();
                        this.$emit('updated');
                    } catch (error) {
                        if (error?.response?.status == 422) {
                            if (error?.response?.data.errors) {
                                Object.values(error.response.data.errors)
                                .flat()
                                .forEach(err_message => {
                                    Notification.warning({
                                        title: 'Atenção',
                                        message: err_message
                                    });
                                });
                            }

                            return
                        }

                        Notification.error({
                            title: 'Erro',
                            message: error?.response?.data?.message ?? 'Não foi possível atualizar a notificação!'
                        });
                    } finally {
                        this.isSubmiting = false;
                    }
                })
            },
            /**Modal */
            toggleModal() {
                this.showModal = !this.showModal;
            },
            resetForm() {
                this.$refs.notificacaoForm?.clearValidate();
            },
            /**
             * Utils, Helpers
             */
            validateMin,
        },
        watch: {
            "resource": {
                handler(_newValue) {
                    this.$set(this.payload, 'title', _newValue?.title ?? null);
                    this.$set(this.payload, 'body', _newValue?.body ?? null);
                    this.$set(this.payload, 'frequencia', _newValue?.frequencia ?? null);
                    this.$set(this.payload, 'classe', _newValue?.classe ?? null);
                    this.$set(this.payload, 'ativo', _newValue?.ativo ?? false);
                }
            }
        },
        components: {
            [Row.name]: Row,
            [Col.name]: Col,
            [Notification.name]: Notification,
            [Button.name]: Button,
            [Input.name]: Input,
            [Drawer.name]: Drawer,
            [Switch.name]: Switch,
            [Select.name]: Select,
            [Option.name]: Option,
            [Divider.name]: Divider,
            [Tag.name]: Tag,
            [DatePicker.name]: DatePicker,
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/_macro/notificacao/NotificacaoEditModal.vue